import { create } from 'zustand';
import apiService from '../services/apiService';

const useAdminStore = create((set, get) => ({
  employees: [],
  projects: [],
  loading: false,
  error: null,

  // Employee management
  fetchEmployees: async () => {
    set({ loading: true, error: null });
    try {
      const employeesResp = await apiService.getEmployees();
      const employees = employeesResp?.data || [];
      set({ employees, loading: false });
      return { success: true, data: employees };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  createEmployee: async (employeeData) => {
    set({ loading: true, error: null });
    try {
      const resp = await apiService.createEmployee(employeeData);
      const newEmployee = resp?.data || null;
      const { employees } = get();
      set({ 
        employees: [...employees, newEmployee],
        loading: false 
      });
      return { success: true, data: newEmployee };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  updateEmployee: async (employeeId, updateData) => {
    set({ loading: true, error: null });
    try {
      const resp = await apiService.updateEmployee(employeeId, updateData);
      const updatedEmployee = resp?.data || null;
      const { employees } = get();
      const updatedEmployees = employees.map(emp => 
        emp._id === employeeId ? { ...emp, ...updatedEmployee } : emp
      );
      set({ 
        employees: updatedEmployees,
        loading: false 
      });
      return { success: true, data: updatedEmployee };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  deleteEmployee: async (employeeId) => {
    set({ loading: true, error: null });
    try {
      await apiService.deleteEmployee(employeeId);
      const { employees } = get();
      const filteredEmployees = employees.filter(emp => emp._id !== employeeId);
      set({ 
        employees: filteredEmployees,
        loading: false 
      });
      return { success: true };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  // Project management
  fetchProjects: async () => {
    set({ loading: true, error: null });
    try {
      const projectsResp = await apiService.getProjects();
      const projects = projectsResp?.data || [];
      set({ projects, loading: false });
      return { success: true, data: projects };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  createProject: async (projectData) => {
    set({ loading: true, error: null });
    try {
      const resp = await apiService.createProject(projectData);
      const newProject = resp?.data || null;
      const { projects } = get();
      set({ 
        projects: [...projects, newProject],
        loading: false 
      });
      return { success: true, data: newProject };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  updateProject: async (projectId, updateData) => {
    set({ loading: true, error: null });
    try {
      const resp = await apiService.updateProject(projectId, updateData);
      const updatedProject = resp?.data || null;
      const { projects } = get();
      const updatedProjects = projects.map(proj => 
        proj._id === projectId ? { ...proj, ...updatedProject } : proj
      );
      set({ 
        projects: updatedProjects,
        loading: false 
      });
      return { success: true, data: updatedProject };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  deleteProject: async (projectId) => {
    set({ loading: true, error: null });
    try {
      await apiService.deleteProject(projectId);
      const { projects } = get();
      const filteredProjects = projects.filter(proj => proj._id !== projectId);
      set({ 
        projects: filteredProjects,
        loading: false 
      });
      return { success: true };
    } catch (error) {
      set({ loading: false, error: error.message });
      return { success: false, error: error.message };
    }
  },

  clearError: () => {
    set({ error: null });
  },
}));

export { useAdminStore };
